import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
});

export const setAuthToken = (token) => {
    if (token) {
        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        localStorage.setItem("bt_token", token);
    } else {
        delete api.defaults.headers.common["Authorization"];
        localStorage.removeItem("bt_token");
    }
};

export const getStoredToken = () => localStorage.getItem("bt_token");

export const fileUrl = (storagePath) => {
    const token = getStoredToken();
    if (!storagePath) return "";
    return `${API}/files/${storagePath}?auth=${token}`;
};

export const orderPdfUrl = (orderId) => {
    const token = getStoredToken();
    return `${API}/orders/${orderId}/confirmation.pdf?auth=${token}`;
};

// Route external product images through our backend proxy so the browser
// doesn't get hit by referrer blocks, wrong-slug 404s, or mixed-content warnings.
export const proxyImage = (url) => {
    if (!url) return "";
    if (url.startsWith("blob:") || url.startsWith("data:")) return url;
    return `${API}/image-proxy?url=${encodeURIComponent(url)}`;
};

// Init from storage
const stored = getStoredToken();
if (stored) {
    api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;
}
